<script lang="ts" setup>
import { useNavState, useSidebar } from '@scalar/api-reference'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore dynamic import names
import { data } from '@/assets/IT8m_J06ZLHnViBnG8MRy.js'
import Reference from '@/views/references/Reference.vue'
import {
  type PublishReferenceProps,
  type ReferenceStaticData,
} from '@/views/references/types'

const props = defineProps<PublishReferenceProps>()

/**
 * Set the first tag open
 * This should only ever be run once so we can use a global variable on first set
 * to prevent re-running on each component mount
 */
const firstTag = (data as ReferenceStaticData).parsed?.tags?.[0]
if (
  !import.meta.env.SSR &&
  firstTag &&
  !(window as any)['isLoaded-IT8m_J06ZLHnViBnG8MRy']
) {
  ;(window as any)['isLoaded-IT8m_J06ZLHnViBnG8MRy'] = true

  const { setCollapsedSidebarItem } = useSidebar()
  const { getTagId } = useNavState()
  setCollapsedSidebarItem(getTagId(firstTag), true)
}
</script>

<template>
  <Reference
    v-bind="props"
    :parsed="<any>data.parsed"
    :raw="data.content" />
</template>
